/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Permanent
 * 
 * 1 = Temporary
 */
export enum ContractType {
  Permanent = 0,
  Temporary = 1
}
